var uiKit = {
  datepicker: {
    sunday: 'Domenica',
    monday: 'Lunedí',
    tuesday: 'Martedí',
    wednesday: 'Mercoledí',
    thursday: 'Giovedí',
    friday: 'Venerdí',
    saturday: 'Sabato',
    sunday_short: 'Dom',
    monday_short: 'Lun',
    tuesday_short: 'Mart',
    wednesday_short: 'Mer',
    thursday_short: 'Gio',
    friday_short: 'Ven',
    saturday_short: 'Sab',
    january: 'Gennaio',
    february: 'Febbraio',
    march: 'Marzo',
    april: 'Aprile',
    may: 'Maggio',
    june: 'Giugno',
    july: 'Luglio',
    august: 'Agosto',
    september: 'Settembre',
    october: 'Ottobre',
    november: 'Novembre',
    december: 'Dicembre',
    pick_year: 'Scegli un anno',
    pick_month: 'Scegli un mese',
    pick_date: 'Scegli una data'
  }
};

export default {
  myaccount: {
    backButton: {
      label: 'Back'
    },
    welcomeBar: {
      hi: 'Ciao',
      lastLogin: 'Ultimo accesso',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'Numero',
      fiscalCode: 'Codice Fiscale'
    },
    accountVerification: {
      youHave: 'Ti rimangono',
      days: 'giorni',
      pending: {
        accountUnverified: 'Il tuo conto non è stato ancora verificato',
        verifyNow: 'Verifica Ora',
        whyImportant: 'Perchè questo è importante?'
      },
      rejected: {
        documentsRejected: 'Purtroppo i documenti che hai inviato non sono stati accettati',
        documentsRejectedReason: "Questo potrebbe essere dovuto ad un'immagine caricata non ben visibile, un'incongruenza dei dati o l'utilizzo di un documento sbagliato.",
        documentsRejectedAlreadyUploadedInfo: 'La prego di ignorare questa richiesta se ha già inviato i Suoi documenti.',
        documentsRejectedManualUpload: 'Caricamento Manuale'
      },
      inProgress: {
        verificationInProgress: 'Grazie! I tuoi documenti verranno ora verificati dal nostro team.',
        verificationInProgressInfo: 'Ti notificheremo via email e SMS non appena avremo verificato la tua identità.'
      }
    },
    navigationMenu: {
      title: {
        myBets: 'Scommesse',
        accountHistory: 'Le mie Transazioni',
        withdraw: 'Preleva',
        withdrawAccountVerification: 'Preleva',
        reversalWithdraw: 'Annulla i Prelievi',
        myRewards: 'Promozioni',
        myAccount: 'Il Mio Conto',
        depositLimit: 'Limiti di deposito',
        deposit: 'Deposita'
      }
    },
    myAccountTitles: {
      title: {
        accountHistory: 'Le mie transazioni',
        personalDetails: 'Dettagli personali',
        loginSecuritySettings: 'Login & impostazioni di sicurezza',
        siteSettings: 'Impostazioni'
      },
      listItems: {
        statementsView: 'Estratto conto',
        contactName: 'Nome del contatto',
        contactDetails: 'Dettagli del contatto',
        marketingPreferences: 'Preferenze di comunicazioni',
        autoLogin: 'Auto-login',
        twoFactorAuth: 'Autenticazione in due passaggi',
        password: 'Password',
        oddsFormat: 'Formato quote',
        movementPrices: 'Variazioni di quote'
      }
    },
    accountButton: {
      gameActiveText: '{{mainBalance}}'
    },
    accountBonus: {
      messageText: 'Hai un bonus sul tuo conto!'
    },
    header: {
      error: {
        message: 'I tuoi dati non sono stati ottenuti.',
        retry: 'Riprova'
      },
      title: {
        landing: 'Il Mio Conto',
        myAccount: 'Il Mio Conto',
        myBets: 'Scommesse',
        personalDetails: 'Dettagli personali',
        siteSettings: 'Impostazioni',
        accountHistory: 'Le mie Transazioni',
        loginSecurity: 'Login e Sicurezza',
        depositLimit: 'Limiti di deposito',
        deposit: 'Deposito'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Saldo',
      additionalBalance: {
        sportsbook: 'Bonus',
        gaming: 'BONUS CASH - Casinò, Vegas e Live',
        vegas: 'BONUS CASH - Casinò, Vegas e Live',
        casino: 'BONUS CASH - Casinò, Vegas e Live'
      },
      balanceInfoLink: 'Clicca qui per i Dettagli dei tuoi bonus'
    },
    transactions: {
      reference: 'Rif.',
      aamsId: 'Codice AAMS:',
      EW: 'EW',
      eachWay: 'EW 1-{{places}} Places, {{price}} Price',
      stake: 'Puntata',
      refund: 'Rimborsato',
      return: 'Ritorno',
      amount: 'Importo',
      bonusStake: 'Puntata Bonus',
      stakeTotal: 'Puntata Totale',
      myBets: {
        open: 'Aperte',
        settled: 'Chiuse'
      },
      numberOfLines: 'x {{value}} Scommesse',
      type: {
        BET_ACCUMULATOR_10: 'Multipla (10)',
        BET_ACCUMULATOR_11: 'Multipla (11)',
        BET_ACCUMULATOR_12: 'Multipla (12)',
        BET_ACCUMULATOR_13: 'Multipla (13)',
        BET_ACCUMULATOR_14: 'Multipla (14)',
        BET_ACCUMULATOR_15: 'Multipla (15)',
        BET_ACCUMULATOR_16: 'Multipla (16)',
        BET_ACCUMULATOR_17: 'Multipla (17)',
        BET_ACCUMULATOR_18: 'Multipla (18)',
        BET_ACCUMULATOR_19: 'Multipla (19)',
        BET_ACCUMULATOR_20: 'Multipla (20)',
        BET_ACCUMULATOR_21: 'Multipla (21)',
        BET_ACCUMULATOR_22: 'Multipla (22)',
        BET_ACCUMULATOR_23: 'Multipla (23)',
        BET_ACCUMULATOR_24: 'Multipla (24)',
        BET_ACCUMULATOR_25: 'Multipla (25)',
        BET_ACCUMULATOR_4: 'Multipla (4)',
        BET_ACCUMULATOR_5: 'Multipla (5)',
        BET_ACCUMULATOR_6: 'Multipla (6)',
        BET_ACCUMULATOR_7: 'Multipla (7)',
        BET_ACCUMULATOR_8: 'Multipla (8)',
        BET_ACCUMULATOR_9: 'Multipla (9)',
        BET_CANADIAN: 'Canadian',
        BET_DDB: 'Tote - Daily Double',
        BET_DOUBLE: 'Doppia',
        BET_DOUBLES: 'Doppio',
        BET_EIGHTFOLDS: 'Combinadas de 8',
        BET_EXA: 'Tote - Exacta',
        BET_FIVEFOLDS: 'Fivefolds',
        BET_FLG: 'Flag',
        BET_FOURFOLDS: 'Fourfolds',
        BET_GOLIATH: 'Goliath',
        BET_HEINZ: 'Heinz',
        BET_LUCKY_15: 'Lucky 15',
        BET_LUCKY_31: 'Lucky 31',
        BET_LUCKY_63: 'Lucky 63',
        BET_MAN: 'Written Bet',
        BET_NINEFOLDS: 'Ninefolds',
        BET_PATENT: 'Patent',
        BET_PK3: 'Tote - Pick 3',
        BET_PK4: 'Tote - Pick 4',
        BET_PK6: 'Tote - Pick 6',
        BET_PK9: 'Tote - Pick 9',
        BET_PLC: 'Tote - Place',
        BET_QIN: 'Tote - Quinella',
        BET_ROB: 'Round Robin',
        BET_SEVENFOLDS: 'Sevenfolds',
        BET_SHW: 'Tote - Show',
        BET_SINGLE: 'Singola',
        BET_SIXFOLDS: 'Sixfolds',
        BET_SPR: 'Tote - Superfecta',
        BET_SUPER_HEINZ: 'Super Heinz',
        BET_TENFOLDS: 'Tenfolds',
        BET_TREBLE: 'Tripla',
        BET_TREBLES: 'Triple',
        BET_TRI: 'Tote - Trifecta',
        BET_TRIXIE: 'Trixie',
        BET_UEXA: 'Tote - Exacta',
        BET_UJKP: 'Tote - Jackpot',
        BET_UKN: 'Scommessa',
        BET_UPLC: 'Tote - Place',
        BET_UPLP: 'Tote - Placepot',
        BET_UQDP: 'Tote - Quadpot',
        BET_USC6: 'Tote - Scoop 6',
        BET_USC7: 'Tote - Super7',
        BET_USW: 'Tote - Swinger',
        BET_UTD: 'Tote - Doppia',
        BET_UTRI: 'Tote - Trifecta',
        BET_UTT: 'Tote - Treble',
        BET_UWIN: 'Tote - Win',
        BET_WIN: 'Tote - Vincita',
        BET_YANKEE: 'Yankee',
        BONUS: 'Balance adjustment',
        DEPOSIT: 'Deposito',
        PRIORITY_CARD_CASH: 'Contanti',
        PRIORITY_CARD_CASHBACK: 'Purchase with cashback',
        PRIORITY_CARD_DEPOSIT: 'Deposito',
        PRIORITY_CARD_NON_CASH: 'Non-cash',
        PRIORITY_CARD_OTHER: 'Altro',
        PRIORITY_CARD_PURCHASE: 'Acquisto',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Rimborso',
        PRIORITY_CARD_TRANSACTION: 'Pagamento',
        REVERSAL: 'Annulla Prelievo',
        MANUAL_ADJUSTMENT: 'Regolazione Manuale',
        WITHDRAWAL: 'Prelievo',
        TRANSFER: 'Trasferimento',
        CASINO: 'Casino',
        VEGAS: 'Vegas'
      },
      manualAdjustmentType: {
        AFFP: 'Affiliate Payments',
        AFFR: 'Affiliate Rakeback',
        BCNV: 'Balance Conversion',
        BETC: 'Bet Correction',
        BNJW: 'Vincita con Jackpot',
        BNKC: 'Commissioni bancarie',
        BONS: 'Manual Bonus',
        BPCS: 'Pagamento Bonus (cs)',
        BTCS: 'Balance Transfer (cs)',
        CADJ: 'Commission Adjustment',
        CSH: 'Cash Adjustments',
        CWIN: 'Vincite tagliate',
        GWCS: 'Gesture of Goodwill (cs)',
        GWIL: 'Gesture of Goodwill',
        HEDG: 'Hedging',
        INAC: 'Inactivity Charge',
        ISCS: 'Referto non corretto (cs)',
        LFND: 'Fondi Intrappolati',
        MCM: 'Manual Cash Movement',
        ONCR: 'On-Course',
        PGCW: 'Pre GC Write Off',
        RCHQ: 'Return Cheque',
        SCHQ: 'Stop Cheque',
        TFCS: 'Fondi intrappolati (cs)',
        WOFF: 'Write Off'
      },
      result: {
        WIN: 'Vincente',
        LOST: 'Perdente',
        VOIDED: 'Annullata',
        STAKE: 'Puntata',
        CASHED_IN: 'Cashed in',
        CANCELED: 'Cancellato',
        PLACED: 'Piazzata'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Bonifico Bancario',
        CARD: 'Carta di Credito/Debito',
        CHEQUE: 'Cheque',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Bonifico Bancario Diretto',
        ECOPAYZ: 'EcoPayz',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        FASTBANKTRANSFER: 'Bonifico Veloce',
        KALIBRA: 'Kalibra',
        NETELLER: 'Neteller',
        OTHER: 'Altro',
        PAYPAL: 'Paypal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        POSTEPAY: 'Postepay',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter',
        WHVOUCHER: 'WH Voucher'
      },
      sort: {
        ANYTIME_SCORECAST: 'Anytime Scorecast',
        ANYTIME_WINCAST: 'Combo Marcatori',
        ASIAN_HANDICAP: 'Handicap Asiatico',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Primi quattro in Combinata',
        COMBINATION_FORECAST: 'Accoppiata in Combinata',
        COMBINATION_QUINELLA: 'Combination Quinella',
        COMBINATION_TRICAST: 'Tris in Combinata',
        CONTINUOUS_WIN: 'Continuous Win',
        FIRST_FOUR: 'Primi quattro',
        FIRST_HALF_ASIAN_HANDICAP: 'Primo tempo Handicap Asiatico',
        FIRST_HALF_OUTRIGHT: '1st Half Outright',
        FIRST_HALF_WESTERN_HANDICAP: '1st Half Western Handicap',
        FIRST_WINCAST: 'First Wincast',
        FORECAST: 'Accoppiata',
        HIGHER_LOWER: 'Piú alto/basso',
        HIGHER_LOWER_SPLIT_OFFER: 'Piú Alto/Basso (with split offer)',
        INSURED_SCORECAST: 'Insured Scorecast',
        INSURED_WINCAST: 'Insured Wincast',
        LAST_SCORECAST: 'Last Scorecast',
        LAST_WINCAST: 'Last Wincast',
        MATCH_HANDICAP: 'Match Handicap',
        OVER_UNDER: 'Over/Under',
        PERMED_FORECAST: 'Permed Forecast',
        PERMED_TRICAST: 'Permed Tricast',
        POINTS_MARKET: 'Points Market',
        QUINELLA: 'Quinella',
        REVERSE_FORECAST: 'Accoppiata Non in Ordine',
        SCORECAST: 'Scorecast',
        SECOND_HALF_ASIAN_HANDICAP: 'Secondo tempo Handicap Asiatico',
        SECOND_HALF_OUTRIGHT: '2nd Half Outright',
        SECOND_HALF_WESTERN_HANDICAP: '2nd Half Western Handicap',
        SIMPLE: 'Singola',
        STANDOUT_FIRST_FOUR: 'Standout First Four',
        STANDOUT_FORECAST: 'Standout Forecast',
        STANDOUT_QUINELLA: 'Standout Quinella',
        STANDOUT_TRICAST: 'Standout Tricast',
        STRAIGHT_FORECAST: 'Accoppiata in Ordine',
        TRICAST: 'Trio',
        TRICAST_OPTIONS: 'Tricast Options',
        WESTERN_HANDICAP: 'Western (straight) Handicap',
        XTH_SCORER_SCORECAST: 'Xth Scorer Scorecast',
        XTH_SCORER_WINCAST: 'Xth Scorer Wincast'
      },
      boostedBet: 'Boosted Bet',
      loadMore: 'Carica di piú',
      noTransactions: 'Nessun transazione.',
      resetFilters: {
        filtersApplied: 'Applica filtri',
        removeFilters: 'Rimuovi tutto'
      }
    },
    filters: {
      dropdown: {
        transactionsHistory: {
          date: 'Ultimi 7 giorni',
          filters: 'Filtri'
        }
      },
      customDateRange: {
        toLabel: 'to',
        labels: {
          from: 'da',
          to: 'a'
        },
        error: 'Per favore seleziona un periodo valido o una data diversa.',
        historyLimitation: {
          caption: 'Ti informiamo che le transazioni più vecchie di un anno potrebbero non essere disponibili. ' + 'Se desideri visualizzarle, ti invitiamo a contattare il ',
          link: 'Servizio Clienti.'
        }
      },
      predefinedDateRange: {
        sectionName: 'Periodi Predefiniti',
        allDates: 'Tutte le date',
        last7: 'Ultimi 7 giorni',
        last14: 'Ultimi 14 giorni',
        last30: 'Ultimi 30 giorni',
        custom: 'Scegli il Periodo'
      },
      view: {
        sectionName: 'Visualizza',
        all: 'Tutto',
        onlyPayments: 'Solo i Pagamenti (Depositi/Prelievi)',
        excludePayments: 'Escludi i Pagamenti (Depositi/Prelievi)',
        onlyWins: 'Solo le Scommesse Vincenti',
        onlyLosses: 'Solo le Scommesse Perdenti'
      },
      showHideBetTypes: {
        sectionName: 'Visualizza / Nascondi Scommesse',
        singles: 'Singole',
        multiples: 'Multiple'
      },
      tabs: {
        all: 'Tutto',
        sports: 'Sport',
        gaming: 'Giochi'
      },
      applyFilters: 'Applica'
    },
    footer: {
      button: {
        logout: {
          text: 'Logout'
        }
      },
      link: {
        feedback: 'Feedback',
        help: 'Aiuto'
      }
    },
    autoAccept: {
      note: 'Accetta variazioni di quote',
      error: {
        save: 'Ci dispiace, le tue modifiche non possono essere salvate al momento. Riprova gentilmente.'
      }
    },
    personalDetails: {
      tabs: {
        contact: 'Contatti',
        marketing: 'Comunicazioni'
      }
    },
    personalDetailsContact: {
      fields: {
        email: {
          label: 'Indirizzo email'
        },
        addressLine1: {
          label: 'Indirizzo di residenza'
        },
        addressLine2: {
          label: 'Numero Civico'
        },
        addressCity: {
          label: 'Città'
        },
        addressPostcode: {
          label: 'CAP'
        },
        province: {
          label: 'Provincia'
        },
        country: {
          label: 'Nazione',
          defaultValue: "Seleziona dall'elenco.",
          password: 'Password'
        },
        mobile: {
          label: 'Numero di cellulare'
        }
      },
      buttons: {
        submit: 'Aggiorna'
      },
      validationRules: {
        email: {
          required: "L'indirizzo e-mail non può essere vuoto.",
          maxLength: "L'indirizzo e-mail è troppo lungo. Massimo 40 caratteri.",
          email: 'Inserire un indirizzo email valido.'
        },
        street1: {
          required: "L'indirizzo è un campo obbligatorio.",
          maxLength: "L'indirizzo di residenza è troppo lungo. 160 caratteri al massimo.",
          pattern: 'Formato errato.'
        },
        street2: {
          required: 'Il numero civico è un campo obbligatorio.',
          maxLength: "L'indirizzo di residenza è troppo lungo.",
          pattern: 'Formato errato.'
        },
        postcode: {
          required: 'Il codice postale non può essere vuoto.',
          pattern: 'Utilizzare solo numeri.',
          minLength: 'Il codice postale è troppo corto.',
          maxLength: 'Il codice postale è troppo lungo.'
        },
        mobile: {
          required: 'Il numero di telefono non può essere vuoto.',
          pattern: 'Carattere non valido sono accettati solo numeri.',
          minLength: 'Il numero è troppo corto.',
          maxLength: 'Il numero è troppo lungo.'
        },
        province: {
          required: 'Seleziona la provincia.'
        },
        city: {
          required: 'La città è un campo obbligatorio'
        }
      },
      securityMessage: {
        title: 'William Hill prende seriamente la sicurezza del tuo conto.',
        navText: 'Conserviamo i tuoi dettagli personali in un luogo sicuro, ' + 'inclusi il tuo nome, indirizzo di residenza, numero di telefono e email. ' + 'Per aggiorare i tuoi dati',
        navigationLink: ' clicca qui',
        navText2: ' o ',
        contact: 'contatta',
        navText3: ' il nostro servizio clienti.',
        navText4: 'Le informazioni aggiornate saranno archiviate nei nostri sistemi, ' + 'ma non verranno visualizzate nella pagina.'
      },
      userData: {
        fiscalCode: 'Codice Fiscale',
        birthPlace: 'Luogo di nascita',
        countyOfBirth: 'Provincia di nascita',
        documentType: "Documento d'identità",
        documentNumber: 'Numero del documento',
        documentReleaseDate: 'Data di emissione',
        documentIssueLocation: 'Luogo di emissione',
        documentTypeIssuer: 'Emesso da'
      },
      documentTypes: {
        id: "Carta d'identità",
        drivingLicense: 'Patente di Guida',
        passport: 'Passaporto'
      },
      statusMessage: {
        success: 'Le tue informazioni sono state aggiornate.',
        failure: 'Qualcosa è andato storto…'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'Desidero ricevere notizie su bonus, offerte e servizi via email, SMS o telefono. ' + 'Puoi aggiornare/modificare le tue preferenze in qualsiasi momento.',
      disclaimer: {
        text: 'Clausola di Esclusione della Responsabilità.',
        note: 'Possono essere necessarie fino a 48 ore affinché le modifiche diventino effettive. ' + 'Tra i servizi offerti, utilizziamo anche le notifiche push. ' + 'Puoi controllare le impostazioni delle notifiche push sul tuo dispositivo. ' + 'Se utilizzi più di un dispositivo per accedere al servizio, ' + 'sarà necessario regolare le impostazioni su ciascuno di essi.'
      },
      contactMethodLabel: {
        telephone: 'Telefono',
        email: 'Email',
        sms: 'SMS'
      },
      error: {
        save: 'Ci dispiace, I tuoi dati non possono essere salvati al momento. Riprova gentilmente.'
      }
    },
    loginSecurity: {
      changePassword: 'Cambia la password',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova Password',
      savePassword: 'Salva nuova password',
      passwordUpdated: 'La tua password è stata aggiornata.',
      genericErrorMessage: 'Qualcosa è andato storto…',
      validationRules: {
        currentPassword: {
          required: 'La password attuale  non può essere vuoto.',
          invalidCredentials: 'Password sbagliata.'
        },
        newPassword: {
          required: 'Il nuovo campo password non può essere vuoto.',
          minLength: 'La password deve contenere almeno 8 caratteri.',
          maxLength: 'La password deve contenere massimo 15 caratteri.',
          forbiddenChars: 'La password non può contenere i seguenti caratteri: ; \' " \\ ? # ~ ; : + = ( ) & %.',
          allowedChars: 'La password non può contenere i seguenti caratteri: ; \' " \\ ? # ~ ; : + = ( ) & %.',
          forbiddenWords: "La password inserita è troppo vulnerabile. Ti preghiamo di sceglierne un'altra.",
          hasDigit: 'La password deve contenere: minimo 8 caratteri, un numero, una lettera minuscola e una lettera maiuscola. ' + 'Non deve far riferimento al tuo username, nome, cognome o data di nascita.',
          hasUppercaseLetter: 'La password deve contenere: minimo 8 caratteri, un numero, una lettera minuscola e una lettera maiuscola. ' + 'Non deve far riferimento al tuo username, nome, cognome o data di nascita.',
          pattern: 'La password deve contenere: minimo 8 caratteri, un numero, una lettera minuscola e una lettera maiuscola. ' + 'Non deve far riferimento al tuo username, nome, cognome o data di nascita.',
          cannotContainFirstName: 'La password non può includere il tuo nome.',
          cannotContainLastName: 'La password non può includere il tuo cognome.',
          cannotContainUsername: 'La password non può includere il nome utente.',
          cannotContainDateOfBirth: 'La password non può includere la data di nascita.',
          cannotBeEqualToLastPassword: 'La password nuova non può essere uguale alla password attuale.'
        },
        infoLabel: 'Scegli una password sicura ma facile da ricordare.',
        genericRules: 'Deve contenere dagli 8 ai 15 caratteri. Non si accettano i simboli ; \' " \\ ? # ~ ; : + = ( ) & %. ' + 'Non deve far riferimento al tuo username, nome, cognome o data di nascita.'
      }
    },
    depositLimit: {
      label: 'Limiti di deposito',
      noticeMessage: 'Prendi il controllo del tuo denaro ed imposta il limite di ' + " deposito sul tuo conto William Hill. L'aumento del limite di " + ' deposito sarà effettivo dopo 7 giorni. ',
      noticeLinkLabel: 'Come funziona?',
      ctaLabel: 'Salva modifiche',
      successMessage: 'Il nuovo limite di deposito è stato impostato.',
      increasedSuccessMessage: 'La richiesta per aumentare il limite di deposito è stata accettata. ' + "L'aumento del limite di deposito sarà effettivo dopo 7 giorni.",
      limits: {
        day: 'Limite Giornaliero',
        week: 'Limite Settimanale',
        month: 'Limite Mensile'
      },
      limitNotSet: 'Non impostato.',
      chooseNewLimit: 'Scegli un nuovo limite',
      inputPlaceholder: "Inserisci l'importo",
      increaseLimitLinks: {
        day: 'Voglio aumentare il mio limite giornaliero.',
        week: 'Voglio aumentare il mio limite settimanale.',
        month: 'Voglio aumentare il mio limite mensile.'
      },
      otherValue: 'Altro importo',
      pendingRequestText: 'La tua richiesta di aumento del limite di deposito a {{requestAmount}} ' + 'sarà effettiva a partire dal {{requestEffectiveFrom}}.'
    },
    contactCustomerService: ' Una richiesta per aumentare il limite di deposito risulta giá in processo,' + '  non potrai quindi procedere ad un ulteriore cambio. ' + 'Se desideri cambiare il limite, ti chiediamo gentilmente di contattare il Customer Service cliccando ',
    customerServiceLink: 'qui.',
    changePendingRequest: 'Se desideri modificarli, contatta il nostro servizio clienti.',
    error: {
      network: {
        text: 'Errore nel collegamento.',
        subText: 'Ti chiediamo gentilmente di riprovare.',
        retrySubText: 'Ti chiediamo gentilmente di cliccare su "il Mio Conto".'
      },
      graphQL: {
        text: 'Oops, non troviamo I dati richiesti.',
        subText: 'Ti chiediamo gentilmente di riprovare.',
        retrySubText: 'Ti chiediamo gentilmente di cliccare su "il Mio Conto".'
      },
      retry: 'Riprova',
      iconAlt: 'Cono di Traffico',
      loginPreferences: {
        title: 'Preferenze di Login',
        options: {
          pin: 'Pin',
          faceID: 'Usa faceID',
          touchID: 'Usa touchID',
          none: 'Non salvare i dati di login.',
          autoLogin: 'Auto-login',
          rememberUserName: 'Ricorda username'
        },
        error: {
          save: 'Ci dispiace, I tuoi dati non possono essere salvati al momento. Riprova gentilmente.'
        }
      }
    }
  },
  countries: {
    COUNTRY_AD: 'Andorra',
    COUNTRY_AE: 'Emirati Arabi Uniti',
    COUNTRY_AF: 'Afghanistan',
    COUNTRY_AG: 'Antigua E Barbuda',
    COUNTRY_AI: 'Anguilla',
    COUNTRY_AL: 'Albania',
    COUNTRY_AM: 'Armenia',
    COUNTRY_AN: 'Antille Olandesi',
    COUNTRY_AO: 'Angola',
    COUNTRY_AQ: 'Antartide',
    COUNTRY_AR: 'Argentina',
    COUNTRY_AS: 'Samoa Americane',
    COUNTRY_AT: 'Austria',
    COUNTRY_AU: 'Australia',
    COUNTRY_AW: 'Aruba',
    COUNTRY_AX: 'Isole Åland',
    COUNTRY_AZ: 'Azerbaigian',
    COUNTRY_BA: 'Bosnia Ed Erzegovina',
    COUNTRY_BB: 'Barbados',
    COUNTRY_BC: 'Columbia Britannica',
    COUNTRY_BD: 'Bangladesh',
    COUNTRY_BE: 'Belgio',
    COUNTRY_BF: 'Burkina Faso',
    COUNTRY_BG: 'Bulgaria',
    COUNTRY_BH: 'Bahrein',
    COUNTRY_BI: 'Burundi',
    COUNTRY_BJ: 'Benin',
    COUNTRY_BM: 'Bermude',
    COUNTRY_BN: 'Brunei',
    COUNTRY_BO: 'Bolivia',
    COUNTRY_BP: 'Bophuthatswana',
    COUNTRY_BR: 'Brasile',
    COUNTRY_BS: 'Bahamas',
    COUNTRY_BT: 'Bhutan',
    COUNTRY_BV: 'Isola Bouvet',
    COUNTRY_BW: 'Botswana',
    COUNTRY_BY: 'Bielorussia',
    COUNTRY_BZ: 'Belize',
    COUNTRY_CA: 'Canada',
    COUNTRY_CC: 'Isole Cocos (Keeling)',
    COUNTRY_CD: 'Congo Repubblica Popolare',
    COUNTRY_CF: 'Repubblica Centroafricana',
    COUNTRY_CG: 'Congo Repubblica Democratica',
    COUNTRY_CH: 'Svizzera',
    COUNTRY_CI: "Costa D'Avorio",
    COUNTRY_CK: 'Isole Cook',
    COUNTRY_CL: 'Cile',
    COUNTRY_CM: 'Camerun',
    COUNTRY_CN: 'Cina Repubblica Popolare',
    COUNTRY_CO: 'Colombia',
    COUNTRY_CR: 'Costa Rica',
    COUNTRY_CU: 'Cuba',
    COUNTRY_CV: 'Capo Verde',
    COUNTRY_CX: 'Christmas Isole',
    COUNTRY_CY: 'Cipro',
    COUNTRY_CZ: 'Repubblica Ceca',
    COUNTRY_DE: 'Germania',
    COUNTRY_DJ: 'Gibuti',
    COUNTRY_DK: 'Danimarca',
    COUNTRY_DM: 'Dominica',
    COUNTRY_DO: 'Repubblica Dominicana',
    COUNTRY_DZ: 'Algeria',
    COUNTRY_EC: 'Ecuador',
    COUNTRY_EE: 'Estonia',
    COUNTRY_EG: 'Egitto',
    COUNTRY_EH: 'Sahara Occidentale',
    COUNTRY_ER: 'Eritrea',
    COUNTRY_ES: 'Spagna',
    COUNTRY_ET: 'Etiopia',
    COUNTRY_EU: 'Unione Europea',
    COUNTRY_FI: 'Finlandia',
    COUNTRY_FJ: 'Figi O Viti',
    COUNTRY_FK: 'Isole Falkland',
    COUNTRY_FM: 'Micronesia Stati Federati',
    COUNTRY_FO: 'Faer Oer',
    COUNTRY_FR: 'Francia',
    COUNTRY_FX: 'Francia Metropolitana',
    COUNTRY_GA: 'Gabon',
    COUNTRY_GD: 'Grenada',
    COUNTRY_GE: 'Georgia',
    COUNTRY_GF: 'Guyana Francese',
    COUNTRY_GG: 'Guernsey',
    COUNTRY_GH: 'Ghana',
    COUNTRY_GI: 'Gibilterra',
    COUNTRY_GL: 'Groenlandia',
    COUNTRY_GM: 'Gambia',
    COUNTRY_GN: 'Guinea',
    COUNTRY_GP: 'Guadalupa',
    COUNTRY_GQ: 'Guinea Equatoriale',
    COUNTRY_GR: 'Grecia',
    COUNTRY_GS: 'Georgia del Sud',
    COUNTRY_GT: 'Guatemala',
    COUNTRY_GU: 'Guam',
    COUNTRY_GW: 'Guinea Bissau',
    COUNTRY_GY: 'Guyana',
    COUNTRY_HK: 'Hong Kong',
    COUNTRY_HM: 'Isole Heard e McDonald',
    COUNTRY_HN: 'Honduras',
    COUNTRY_HR: 'Croazia',
    COUNTRY_HT: 'Haiti',
    COUNTRY_HU: 'Ungheria',
    COUNTRY_ID: 'Indonesia',
    COUNTRY_IE: 'Irlanda',
    COUNTRY_IL: 'Israele',
    COUNTRY_IM: 'Isola di Man',
    COUNTRY_IN: 'India',
    COUNTRY_IO: "Territorio Britannico dell'Oceano Indiano",
    COUNTRY_IQ: 'Iraq',
    COUNTRY_IR: 'Iran',
    COUNTRY_IS: 'Islanda',
    COUNTRY_IT: 'Italia',
    COUNTRY_JE: 'Baliato di Jersey',
    COUNTRY_JM: 'Giamaica',
    COUNTRY_JO: ' Giordania',
    COUNTRY_JP: 'Giappone',
    COUNTRY_KE: 'Kenya',
    COUNTRY_KG: 'Kirghizistan',
    COUNTRY_KH: 'Cambogia',
    COUNTRY_KI: 'Kiribati',
    COUNTRY_KM: 'Comore',
    COUNTRY_KN: 'Saint Kitts E Nevis',
    COUNTRY_KP: 'Repubblica Popolare Democratica di Corea',
    COUNTRY_KR: 'Repubblica Di Corea (Corea del Sud)',
    COUNTRY_KW: 'Kuwait',
    COUNTRY_KY: 'Cayman (Isole)',
    COUNTRY_KZ: 'Kazakhstan',
    COUNTRY_LA: 'Laos',
    COUNTRY_LB: 'Libano',
    COUNTRY_LC: 'Saint Lucia',
    COUNTRY_LI: 'Liechtenstein',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Liberia',
    COUNTRY_LS: 'Lesotho',
    COUNTRY_LT: 'Lituania',
    COUNTRY_LU: 'Lussemburgo',
    COUNTRY_LV: 'Lettonia',
    COUNTRY_LY: 'Libia',
    COUNTRY_MA: 'Marocco',
    COUNTRY_MC: 'Monaco',
    COUNTRY_MD: 'Moldavia',
    COUNTRY_ME: 'Montenegro',
    COUNTRY_MG: 'Madagascar',
    COUNTRY_MH: 'Isole Marshall',
    COUNTRY_MK: 'Macedonia del Nord',
    COUNTRY_ML: 'Mali',
    COUNTRY_MM: 'Myanmar',
    COUNTRY_MN: 'Mongolia',
    COUNTRY_MO: 'Macao',
    COUNTRY_MP: 'Isole Marianne Settentrionali',
    COUNTRY_MQ: 'Martinica',
    COUNTRY_MR: 'Mauritania',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Malta',
    COUNTRY_MU: 'Mauritius',
    COUNTRY_MV: 'Maldive',
    COUNTRY_MW: 'Malawi',
    COUNTRY_MX: 'Messico',
    COUNTRY_MY: 'Malaysia',
    COUNTRY_MZ: 'Mozambico',
    COUNTRY_NA: 'Namibia',
    COUNTRY_NC: 'Nuova Caledonia',
    COUNTRY_NE: 'Niger',
    COUNTRY_NF: 'Isole Norfolk',
    COUNTRY_NG: 'Nigeria',
    COUNTRY_NI: 'Nicaragua',
    COUNTRY_NL: 'Paesi Bassi',
    COUNTRY_NO: 'Norvegia',
    COUNTRY_NP: 'Nepal',
    COUNTRY_NR: 'Nauru',
    COUNTRY_NU: 'Niue',
    COUNTRY_NZ: 'Nuova Zelanda',
    COUNTRY_OM: 'Oman',
    COUNTRY_PA: 'Panama',
    COUNTRY_PE: 'Peru',
    COUNTRY_PF: 'Polinesia Francese',
    COUNTRY_PG: 'Papua Nuova Guinea',
    COUNTRY_PH: 'Filippine',
    COUNTRY_PK: 'Pakistan',
    COUNTRY_PL: 'Polonia',
    COUNTRY_PM: 'Saint Pierre Et Miquelon',
    COUNTRY_PN: 'Pitcairn',
    COUNTRY_PR: 'Puerto Rico',
    COUNTRY_PS: 'Territori Palestinesi',
    COUNTRY_PT: 'Portogallo',
    COUNTRY_PW: 'Palau Repubblica',
    COUNTRY_PY: 'Paraguay',
    COUNTRY_QA: 'Qatar',
    COUNTRY_RE: 'La Reunion',
    COUNTRY_RO: 'Romania',
    COUNTRY_RS: 'Serbia',
    COUNTRY_RU: 'Russia (Federazione Russa)',
    COUNTRY_RW: 'Ruanda',
    COUNTRY_SA: 'Arabia Saudita',
    COUNTRY_SB: 'Isole Salomone',
    COUNTRY_SC: 'Seicelle',
    COUNTRY_SD: 'Sudan',
    COUNTRY_SE: 'Svezia',
    COUNTRY_SG: 'Singapore',
    COUNTRY_SH: "Sant'Elena",
    COUNTRY_SI: 'Slovenia',
    COUNTRY_SJ: 'Svalbard e Jan Mayen',
    COUNTRY_SK: 'Slovacchia',
    COUNTRY_SL: 'Sierra Leone',
    COUNTRY_SM: 'San Marino',
    COUNTRY_SN: 'Senegal',
    COUNTRY_SO: 'Somalia',
    COUNTRY_SR: 'Suriname',
    COUNTRY_ST: "Sao Tome' E Principe",
    COUNTRY_SV: 'El Salvador',
    COUNTRY_SY: 'Siria',
    COUNTRY_SZ: 'Swaziland',
    COUNTRY_TA: 'Tristan da Cunha',
    COUNTRY_TC: 'Isole Turks e Caicos',
    COUNTRY_TD: 'Ciad',
    COUNTRY_TF: 'Terre Australi e Antartiche Francesi',
    COUNTRY_TG: 'Togo',
    COUNTRY_TH: 'Thailandia',
    COUNTRY_TJ: 'Tagikistan',
    COUNTRY_TK: 'Tokelau',
    COUNTRY_TM: 'Turkmenistan',
    COUNTRY_TN: 'Tunisia',
    COUNTRY_TO: 'Tonga',
    COUNTRY_TP: 'Timor Orientale',
    COUNTRY_TR: 'Turchia',
    COUNTRY_TT: 'Trinidad E Tobago',
    COUNTRY_TV: 'Tuvalu',
    COUNTRY_TW: 'Taiwan',
    COUNTRY_TZ: 'Tanzania',
    COUNTRY_UA: 'Ucraina',
    COUNTRY_UG: 'Uganda',
    COUNTRY_UK: 'Regno Unito',
    COUNTRY_UM: "Isole Minori Esterne Degli Stati Uniti d'America",
    COUNTRY_US: "Stati Uniti D'America",
    COUNTRY_UY: 'Uruguay',
    COUNTRY_UZ: 'Uzbekistan',
    COUNTRY_VA: 'Citta Del Vaticano',
    COUNTRY_VC: 'Saint Vincent E Grenadine',
    COUNTRY_VE: 'Venezuela',
    COUNTRY_VG: 'Isole Vergini Britanniche',
    COUNTRY_VI: 'Isole Vergini (USA)',
    COUNTRY_VN: 'Vietnam',
    COUNTRY_VU: 'Vanuatu',
    COUNTRY_WE: 'Samoa Occidental',
    COUNTRY_WF: 'Isole Wallis e Futuna',
    COUNTRY_WS: 'Samoa',
    COUNTRY_YE: 'Yemen',
    COUNTRY_YT: 'Mayotte',
    COUNTRY_ZA: 'Repubblica Sudafricana',
    COUNTRY_ZM: 'Zambia',
    COUNTRY_ZW: 'Zimbabwe'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Oggi',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    }
  }
};